import { PlusCircle } from "lucide-react";

export default function InvoicesHeader({ openModal }) {
  return (
    <div className="flex items-center justify-between">
      <h1 className="text-2xl font-semibold text-gray-800">Invoices</h1>
      <button
        onClick={openModal}
        className="flex items-center gap-2 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition"
      >
        <PlusCircle className="w-5 h-5" />
        Add Invoice
      </button>
    </div>
  );
}
